import { sortTheList } from "@/utils/sortTheList";
import type { TableColumn } from "@maersk-global/mds-components-core/mc-table/types";

const acceptedFormats = [
    "doc", // Microsoft Word
    "docx", // Microsoft Word
    "xls", // Microsoft Excel
    "xlsx", // Microsoft Excel
    "ppt", // Microsoft PowerPoint
    "pptx", // Microsoft PowerPoint
    "mdb", // Microsoft Access
    "xltx", // Excel Template
    "dotx", // Word Template
    "potx", // PowerPoint Template
    "pbix", // Power BI
    "pdf", // Document
    "jpg", // Image
    "jpeg", // Image
    "png", // Image
    "zip", // Compressed
    "svg", // Scalable Vector Graphics
    "txt", // Text
    "msg", // Outlook Email messages
    "eml" // RFC 822 Email messages
  ],
  MAX_ATTACHMENT_SIZE_BYTES = 10 * 1024 * 1024,
  statusConfig = {
    OPENED: ["Opened", "info", "open"],
    IN_PROGRESS: ["In-Progress", "success", "in-progress"],
    CLOSED: ["Closed", "neutral-inverse", "close"]
  },
  sortOptions = {
    LATEST: "Date: Newest first",
    OLDEST: "Date: Oldest first",
    STATUS_DESC: "Status: Opened First",
    STATUS_ASC: "Status: Closed First"
  },
  catalogueTypeList = {
    CATEGORY: "Category",
    SUB_CATEGORY: "Sub Category",
    SERVICE_ACTIVITY: "Service Activity",
    REGION: "Region",
    AREA: "Area"
  },
  viewList = {
    ADMIN: ["Admin Hub", "AdminHubView"],
    PRACTITIONER: ["Practitioner Workbench", "Practitioner"],
    EMPLOYEE: ["Employee Center", "Home"]
  },
  practitionerViewList = {
    PRACTITIONER: ["Practitioner Workbench", "Practitioner"],
    EMPLOYEE: ["Employee Center", "Home"]
  },
  formLinkRedirectURL = "legal-advice/form-assignment/:assignmentId",
  adminModules = [
    {
      heading: "Team Management",
      description: "Configure and manage teams and attributes",
      moduleRoute: "TeamManager"
    },
    /*//  To be enabled in future releases
    {
      heading: "Form Management",
      description: "Configure and manage forms to be linked to catalogue",
      moduleRoute: "FormManager"
    },*/
    {
      heading: "Service Catalogue Management",
      description: "Configure and manage user profile fields and attributes",
      moduleRoute: "ServiceCatalogueManager"
    },
    {
      heading: "Service Catalogue Management",
      description: "Configure and manage user profile fields and attributes",
      moduleRoute: "ServiceCatalogueLanding"
    }
  ],
  makeEntraTeam = (id: string, name: string) => ({ id, mail: "", displayName: name, name }),
  DMSUsersGroup = "45c1bc47-1cdc-47f7-84cc-90883b7fe32e",
  entraGroup = sortTheList(
    [
      {
        id: "a91c1d19-ed41-45ec-8e66-8f22078b917c",
        mail: "ITLegalMailbox_MailboxAccess@maersk.com",
        displayName: "ITLegal",
        name: "IT Legal"
      },
      {
        id: "9b1edede-179c-46f7-a168-2d77c236a4ce",
        displayName: "ProcurementLegal",
        mail: "",
        name: "Procurement Legal"
      },
      {
        id: "b3e926dd-1509-4205-9d13-1d4cd540a226",
        mail: "MaritimeLawTeam@maersk.onmicrosoft.com",
        displayName: "Maritime Law Team",
        name: "Maritime Law"
      },
      makeEntraTeam("24df273d-48f9-46c6-ab45-8fcfbe7e6cca", "Data Privacy Legal"),
      makeEntraTeam("dd524d69-23b7-4932-b164-8effcfc72769", "IP Legal"),
      ...(
        [
          ["02c7a3cf-f627-455f-9b61-fbfcd4a047fc", "SWE Legal"],
          ["67ffbdfb-938e-4752-89da-7b093a86ee61", "NEC Legal"],
          ["be15ccba-9c39-4349-8e41-67c27119e60b", "NDC Legal"],
          ["ba57698d-7ff6-4471-95ce-477c5b5fe94c", "UK&I Legal Team"],
          ["fbae3f95-009d-449a-9fc3-c2c60cb95185", "EME Legal"],
          ["2e611fb2-9cb2-460c-80fa-f850aeb8fe6d", "CSE Legal"],
          ["a6487d8f-5675-4ad4-96eb-35ad762a3eb0", "Projects (Invest/Divest) Legal"],
          ["dd42db30-3859-4b6b-88ce-7823c78f1391", "Commercial Contracts Legal"],
          ["3d6a9d29-732a-4f64-b329-f2e2df460ea8", "GCA Legal Team"],
          ["65448a46-8416-4158-ace9-bb46355d5c77", "NEA Legal Team"],
          ["929519b3-b506-49c7-b9ba-9642363902c1", "MEK Legal"],
          ["cae7ee6b-ec27-487b-b92f-fc53ff20e80e", "SEA Legal Team"],
          ["608f9283-1804-43a8-b59e-4c6cdab3bb82", "OCE Legal"],
          ["89503b34-b181-4bf3-9033-7c0689ab613d", "Region Legal"],
          ["08004dab-50ff-4a7c-b3d8-9b5722ef82c0", "APMT APA Grow Legal"],
          ["60b0b552-4acb-4da3-b843-81b42c73073c", "APMT APA BAU Legal"],
          ["555d4045-d517-407d-a3cf-6c2760fa82ee", "CAC Legal Team"],
          ["57388a0b-9954-41ef-9fed-d87205604cae", "ESCA Legal"],
          ["5d7e3f3b-fbab-4909-bb82-05b20c67e979", "WSCA Legal"],
          ["5085c26e-a194-4c4b-91df-db003e7d2134", "APMT LAM Legal Team"],
          ["c730c049-9b5b-4026-8557-5f39d27363d0", "Ocean & Logistics US and Canada Legal"],
          ["dca434c8-5d79-4daa-8404-2c8b62f122bb", "Employment & Labor Law Legal"],
          ["ba785958-9508-4f39-889b-2a968236d264", "Litigation NAM Legal"],
          ["5dd1d7b6-45b0-4fcb-9365-0e4d0bfcd6f3", "APMT NAM Legal"],
          ["d3ca75cb-3292-42f0-bc67-a05084aa16c8", "Mexico NAM Legal"],
          ["f3218a73-a23f-4c48-9cea-5ca0bf1801e5", "GSC Legal Team"],
          ["d7deb8e6-71b3-4dc9-a285-2b53957c1921", "IBS Team Legal"],
          ["f7174661-8e42-434c-9b2e-4dc24aa8f742", "ME (SAA/UAE/PAK) Legal"],
          ["6702ed0c-4d39-4ffc-8971-9041a7a44ea0", "EAA (East Africa) Legal"],
          ["807af01b-3879-4770-b1cc-d572107a13c1", "SAI (Southern Africa & Islands) Legal"],
          ["8034d38c-e081-4683-83da-9906e66f612d", "WAF (West Africa)"],
          ["1d293361-67e4-4600-b39b-a9e183166d4f", "IMEA L&S Projects Legal"],
          ["894cfc25-1821-405f-b6b2-2f77b5f24a87", "OCL ME Legal"],
          ["f827fcba-4f2f-4e55-a98b-8cef5e1a38fa", "OCL SAI Legal"],
          ["5f9e4e40-e3d4-46c7-ab83-336b1f5b2bea", "APMT IMEA LEGAL"],
          ["e55dc269-e3d8-4fd5-9a74-58c93403d945", "Corporate Legal Team (CLSP)"],
          ["5938071e-acc0-43ad-abce-8ee28dfe6afb", "GEMS Legal Team (CLSP)"],
          ["f4fd2783-b075-49be-907c-1eb649bda4a3", "Signing Requests Legal (CLSP)"],
          ["07ba9e55-9306-4c35-ad03-8a2dc00bc2da", "ISCC Audit and Compliance"],
          ["f6ad4d26-2f35-4ff7-ab99-5b37a698b6bc", "MOT Legal Operations Team"],
          ["e86babe3-b332-406c-aa41-e51376ae0aba", "KYC, Sanction Compliance, and Vessel Screening"],
          ["c3ea2138-fc5f-4ac2-b28b-01d12fdb437b", "Energy Transition Legal Team"]
        ] as [string, string][]
      ).map(([id, name]) => makeEntraTeam(id, name))
    ],
    "name"
  ),
  procurementEntities = ["656", "3", "365", "437", "361", "186"], // GEMS entity IDs
  VALID_CHARS_REGEX =
    /^[\p{L}\p{N}\p{Sc}\p{M}\s!@#%^&*()_+=[\]{}|:;"',\u201C\u201D\u2018\u2019\u201A./?\u20B9\u00A3\u20AC$\u2022\u2026\u2014\u2013\-\uFF0C]+$/u,
  formsWithoutGemsEntityValidation = [
    "ProcurementTemplates",
    "GeneralLegalAdvice",
    "CrisisInvestigation",
    "genericForm",
    "DPCreateUpdateTemplate",
    "DPRiskImpactAssessments",
    "DPGuidanceDataRetentionDeletion",
    "DPRequestCollectionPersonalInformation",
    "DPAiDataPrivacyItTechSupport",
    "DPRequestTraining",
    "DPComplianceAudit",
    "IPRequestCompetitorLandscaping",
    "IPInventorRemuneration",
    "IPRequestWorkshop",
    "IPReviewUnsolicitedOffer",
    "IPStatusCheckPatent",
    "IPSubmissionNewInvention",
    "IPSupportMnaDueDiligence",
    "IPClearanceAssessmentProductName",
    "IPReviewCeaseDesistLetter",
    "IPUseThirdPartyCopyrightedMaterials",
    "IPRequestTraining",
    "IPNocTrademarkLicense",
    "IPCheckNameLogo",
    "IPInvestigateInfringingDomains",
    "IPReportTrademarkMisuse",
    "IPReportEmployeeImpersonation",
    "IPStatusCheckTrademark",
    "IPTrademark",
    "CGSupportCorporateStructureCommittee",
    "CGRequestAdviceCorporateLawGovernance",
    "CGRequestGemsAccess",
    "CGRequestGemsData",
    "CGRequestGemsTraining",
    "CGSupportAPMTTender",
    "CGPowerOfAttorneyDKNL",
    "ETISCCAdvisoryAudit",
    "ETKYCOnboarding",
    "ETCompliance"
  ],
  formsWithoutInfoField = ["CGRequestAdviceCorporateLawGovernance", "CGAssistShareholderBoardMeetingsDKNL"],
  formsRequiringAttachmentValidation = [
    "CGSupportCorporateStructureCommittee",
    "CGCollectCoordinateSignaturesDKNL",
    "CGPowerOfAttorneyDKNL"
  ],
  assignmentActions = {
    UNASSIGN: {
      value: "UNASSIGN",
      label: "Unassign"
    }
  },
  DOC_TYPE_APPEARANCES = ["success", "warning", "info", "error", "neutral-inverse"],
  GUIDANCE_DOCUMENT_TYPE = "Guidance",
  assignmentMetaColumns: Array<TableColumn & { icon: string; size?: string }> = [
    { id: "region", label: "", width: "17%", noWrap: true, icon: "globe", size: "20" },
    { id: "area", label: "", width: "40%", noWrap: true, icon: "pin", size: "20" },
    { id: "legalTeam", label: "", width: "43%", noWrap: true, icon: "users", size: "16" }
  ],
  categoryImageMap: Record<string, string> = {
    claim: "claims_category.svg",
    corporate: "corporate_governance_and_compliance_category.svg",
    customer: "customer_contracts_category.svg",
    data: "data_privacy.svg",
    dispute: "disputes_litigation_category.svg",
    employment: "employment_and_labor_law_category.svg",
    energy: "energy_transition_category.svg",
    general: "general_business_support_category.svg",
    intellectual: "intellectual_property.svg",
    maritime: "maritime_team.svg",
    procurement: "vendor_procurement_contracts.svg",
    tech: "it_team.svg"
  },
  OAUTH_CARD_CONTENT_TYPE = "application/vnd.microsoft.card.oauth",
  LOGIN_REQUEST_CONTENT_TYPE = "application/vnd.microsoft.activity.loginRequest",
  ADAPTIVE_CARD_CONTENT_TYPE = "application/vnd.microsoft.card.adaptive",
  CONTEXT_EVENT_NAME = "pvaSetContext",
  DEFAULT_SERVICE_URL = "https://directline.botframework.com/",
  DEFAULT_CHANNEL_ID = "directline";

// Export all constants at once
export {
  acceptedFormats,
  statusConfig,
  sortOptions,
  catalogueTypeList,
  viewList,
  practitionerViewList,
  formLinkRedirectURL,
  adminModules,
  entraGroup,
  DMSUsersGroup,
  procurementEntities,
  VALID_CHARS_REGEX,
  formsWithoutGemsEntityValidation,
  formsWithoutInfoField,
  formsRequiringAttachmentValidation,
  assignmentActions,
  DOC_TYPE_APPEARANCES,
  MAX_ATTACHMENT_SIZE_BYTES,
  GUIDANCE_DOCUMENT_TYPE,
  categoryImageMap,
  assignmentMetaColumns,
  OAUTH_CARD_CONTENT_TYPE,
  LOGIN_REQUEST_CONTENT_TYPE,
  ADAPTIVE_CARD_CONTENT_TYPE,
  CONTEXT_EVENT_NAME,
  DEFAULT_SERVICE_URL,
  DEFAULT_CHANNEL_ID
};
